/**
 * Which of the viewer's projects their teammates cannot open (P0 2026-10-15,
 * option B): owned, private, shared with nobody, not the demo, not archived.
 * Judged only when the team has someone else in it; a solo founder has nobody
 * to hide from.
 *
 * `members` is what GET /projects?includeCounts=true returns per project
 * (composeProjectMembers on the server): the owner first, then explicit shares,
 * then the whole team only when the project is team-visible. So for a private
 * project, `members.length <= 1` is exactly "zero project_shares". A row whose
 * members were not loaded is skipped: never nag about a project this cannot
 * judge.
 */
export interface VisibilityPromptCandidate {
  id: string;
  name: string;
  role?: string | null;
  visibility?: 'private' | 'team' | null;
  members?: { id: string }[];
  isDemo?: boolean;
  archivedAt?: string | null;
}

export function hiddenFromTeammates<T extends VisibilityPromptCandidate>(projects: T[] | undefined, teamMemberCount: number): T[] {
  if (!projects || teamMemberCount < 2) return [];
  return projects.filter(
    (p) =>
      p.role === 'owner' &&
      p.visibility === 'private' &&
      !p.isDemo &&
      !p.archivedAt &&
      Array.isArray(p.members) &&
      p.members.length <= 1,
  );
}
